<template>
	<div>
		<SectionCard
			:background="background"
			:flat="flat"
		>
			<template #title>
				{{ cardTitle | useLabels }}
			</template>
			<template #title-action>
				<TextButton
					v-if="!readOnly"
					:test-id="fieldId('add_metadata')"
					@click="showMetaDataModal = true"
				>
					<v-icon>
						mdi-plus
					</v-icon>
					Add Metadata
				</TextButton>
			</template>
			<template #body>
				<DataTable
					:items="assignedMetaData"
					:headers="tableHeaders"
				>
					<template #item.action="{ item }">
						<div
							v-if="!readOnly"
							style="display: flex; justify-content: center;"
						>
							<v-menu offset-y>
								<template #activator="{ on, attrs }">
									<v-btn
										icon
										small
										v-bind="attrs"
										v-on="on"
										@click.stop
									>
										<v-icon>
											mdi-dots-horizontal
										</v-icon>
									</v-btn>
								</template>
								<v-list dense>
									<v-list-item
										:data-testid="fieldId(`edit_metadata_${item.metaDataKeyId}_${item.metaDataValue}`)"
										@click="editMetadata(item)"
									>
										<v-list-item-content>
											<v-list-item-title>
												Edit
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item
										:data-testid="fieldId(`delete_metadata_${item.metaDataKeyId}_${item.metaDataValue}`)"
										@click="removeMetadata(item)"
									>
										<v-list-item-content>
											<v-list-item-title>
												Delete
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</template>
				</DataTable>
			</template>
		</SectionCard>
		<MetadataModal
			v-if="showMetaDataModal"
			:module-type="moduleType"
			:assigned-meta-data="assignedMetaData"
			:meta-data-to-edit="metaDataToEdit"
			:component-type-id="componentTypeId"
			@update:metadata="updateMetadata"
			@close="() => {
				showMetaDataModal = false,
				metaDataToEdit = null
			}"
		/>
	</div>
</template>

<script>
import SectionCard from '../../../../shared/components/section-card.vue'
import DataTable from '../../../../shared/components/data-table.vue'
import TextButton from '../../../../shared/components/text-button.vue'
import MetadataModal from './metadata-modal.vue'

export default {
	components: {
		SectionCard,
		DataTable,
		TextButton,
		MetadataModal
	},
	props: {
		moduleType: {
			type: String,
			required: true
		},
		assignedMetaData: Array,
		readOnly: Boolean,
		componentTypeId: Number,
		background: Boolean,
		flat: Boolean
	},
	data () {
		return {
			showMetaDataModal: false,
			metaDataToEdit: null
		}
	},
	computed: {
		cardTitle () {
			return `${this.moduleType} Metadata`
		},
		tableHeaders () {
			const headers = [
				{
					value: 'metaDataKeyName',
					text: 'Metadata Key',
					width: '50%'
				},
				{
					value: 'metaDataValue',
					text: 'Metadata Value',
					width: '50%'
				}
			]
			if (!this.readOnly) {
				headers.push(
					{
						value: 'action',
						text: 'Action',
						align: 'center',
						width: '80px',
						sortable: false
					}
				)
			}
			return headers
		}
	},
	methods: {
		fieldId (field) {
			return `${this.moduleType.toLowerCase().replaceAll(' ', '_')}_${field}`
		},
		updateMetadata (metadata) {
			this.$emit('update:metadata', metadata)
		},
		editMetadata (metadata) {
			this.metaDataToEdit = metadata
			this.showMetaDataModal = true
		},
		removeMetadata (item) {
			const index = this.assignedMetaData.findIndex(
				metadata => metadata.metaDataKeyId === item.metaDataKeyId && metadata.metaDataValue === item.metaDataValue)
			const assignedMetaData = this.assignedMetaData
			assignedMetaData.splice(index, 1)
			this.updateMetadata(assignedMetaData)
		}
	}
}
</script>
